<template>
  <Layout>
    <Title :height="28" imgUrl="url('@/assets/img/bg-serv-white-title.svg')">
      <img src="@/assets/img/buscador-title-logo.svg" class="h-44 w-auto" alt="Buscador Service logo" />
    </Title>
    <About
      title="Se você procurar, vai achar."
      text="Precisa de alguma informação sobre um CPF ou CNPJ e não consegue achar em nenhum lugar? <br> No Buscador Service você vai encontrar! <br> Traga agilidade ao seu trabalho e nunca mais atrase um processo por falta de informações."
      service="buscador"
    />
    <Benefits :solutionId="8" />
    <PlansComparison :solution-id="8" />
    <Solutions title="Mais soluções" />
    <Depoimentos title="Depoimentos" />
    <Faq title="Perguntas Frequentes" :questions="faqStore.questions" />
  </Layout>
</template>

<script lang="ts" setup>
import Layout from '@/components/BaseLayout/Layout.vue';
import Title from '@/components/Title/Title.vue';
import Benefits from '@/components/Benefits/Benefits.vue';
import PlansComparison from '@/components/Plans/PlansComparison.vue';
import Solutions from '@/components/Solutions/Solutions.vue';
import Depoimentos from '@/components/Depoimentos/Depoimentos.vue';
import Faq from '@/components/Faq/Faq.vue';
import { useFaqStore } from '@/store/faqStore';
import About from '@/components/About/About.vue';

const faqStore = useFaqStore();
</script>
